/* eslint-disable @next/next/no-img-element */
import React from "react";
import classNames from "classnames";
import styles from "./teamMemberFullSize.module.scss";

interface ITeamMemberFullSize {
    className?: string;
    contenu: {
        description: string;
        imageUrl: string;
        nom: string;
        type: string;
    };
}

const TeamMemberFullSize = ({ className = "", contenu }: ITeamMemberFullSize) => {
    const { description, imageUrl, nom, type } = contenu;

    return (
        <div
            data-component="TeamMemberFullSize"
            className={classNames(styles.me, {
                [className]: className,
            })}
        >
            <div className={styles.frame}>
                <img src={imageUrl} alt={nom} className={styles.image} />
            </div>
            <div>
                <div className={styles.titleZone}>
                    <h3 className={styles.title}>{nom}</h3>
                    <span className={styles.job}>{type}</span>
                </div>
                <p className={styles.text}>{description}</p>
            </div>
        </div>
    );
};

export default TeamMemberFullSize;
